export const hotelConstants = {
    DATA_REQUEST: 'HOTEL_DATA_REQUEST',
    DATA_SUCCESS: 'HOTEL_DATA_SUCCESS',
    DATA_FAILURE: 'HOTEL_DATA_FAILURE',

    ROOM_CATEGORIES_REQUEST: 'HOTEL_ROOM_CATEGORIES_REQUEST',
    ROOM_CATEGORIES_SUCCESS: 'HOTEL_ROOM_CATEGORIES_SUCCESS',
    ROOM_CATEGORIES_FAILURE: 'HOTEL_ROOM_CATEGORIES_FAILURE',

    MEETING_ROOMS_REQUEST: 'HOTEL_MEETING_ROOMS_REQUEST',
    MEETING_ROOMS_SUCCESS: 'HOTEL_MEETING_ROOMS_SUCCESS',
    MEETING_ROOMS_FAILURE: 'HOTEL_MEETING_ROOMS_FAILURE',

    FACILITIES_REQUEST: 'HOTEL_FACILITIES_REQUEST',
    FACILITIES_SUCCESS: 'HOTEL_FACILITIES_SUCCESS',
    FACILITIES_FAILURE: 'HOTEL_FACILITIES_FAILURE',

    RESTAURANTS_REQUEST: 'HOTEL_RESTAURANTS_REQUEST',
    RESTAURANTS_SUCCESS: 'HOTEL_RESTAURANTS_SUCCESS',
    RESTAURANTS_FAILURE: 'HOTEL_RESTAURANTS_FAILURE',

    BOOKABLE_ITEMS_REQUEST: 'HOTEL_BOOKABLE_ITEMS_REQUEST',
    BOOKABLE_ITEMS_SUCCESS: 'HOTEL_BOOKABLE_ITEMS_SUCCESS',
    BOOKABLE_ITEMS_FAILURE: 'HOTEL_BOOKABLE_ITEMS_FAILURE',

    NOTIFICATION: 'HOTEL_NOTIFICATION',

    FORCE_THEME: 'HOTEL_FORCE_THEME'
};